import { beginsWith } from './string';

export const PATH_ONBOARDING = '/onboarding';

const page = path => location => location && location.pathname && beginsWith(location.pathname, path);

const onboardingPage = page(PATH_ONBOARDING);

export const isOnboardingPage = location => onboardingPage(location);



// WEBPACK FOOTER //
// ./src/utilities/navigation.js